import { cn } from '@/lib/utils'
import Flag from 'react-flagpack'
import { TableCell, TableRow } from '@/components/ui/table'
import { IncludeButton, ExcludeButton } from './IncludeExcludeButtons'
import MinusIcon from '@/components/icons/MinusIcon'
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip'
import { truncateMiddle } from '@/utils/tools'

const CountryName = ({ name }) => {
    if (name.length <= 15) return name

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span className="tw:cursor-default">{truncateMiddle(name, 15)}</span>
            </TooltipTrigger>
            <TooltipContent>
                <span>{name}</span>
            </TooltipContent>
        </Tooltip>
    )
}

const Row = ({
    country,
    countryStates,
    handleIncludeClick,
    handleExcludeClick,
    isLast,
    selectedColumns,
    countryMetrics,
    formatMetricValue,
}) => {
    const state = countryStates.get(country.iso2)

    // Helper function to get metric value from countryMetrics
    const getMetricValue = (apiKey) => {
        const metrics = countryMetrics[country.iso2] || {}
        return metrics[apiKey] || 0
    }

    return (
        <TableRow className={cn('', { 'tw:!border-transparent': isLast })}>
            <TableCell className="tw:pl-3">
                <div className="tw:flex tw:items-center tw:justify-start tw:gap-0.5">
                    <IncludeButton
                        included={state === 'included'}
                        handleChange={() => handleIncludeClick(country.iso2)}
                    />
                    <ExcludeButton
                        excluded={state === 'excluded'}
                        handleChange={() => handleExcludeClick(country.iso2)}
                    />
                </div>
            </TableCell>
            <TableCell className="tw:font-medium tw:flex tw:items-center tw:gap-2 tw:max-w-[140px] tw:pl-1 tw:pr-0">
                <Flag
                    code={country.iso3}
                    className="tw:!w-5 tw:!h-5 tw:!rounded-full tw:!object-cover"
                    hasBorder={false}
                />
                <CountryName name={country.name} />
            </TableCell>
            <TableCell className="tw:text-right tw:pr-1">
                {country.formattedGdp && country.formattedGdp}
                {!country.formattedGdp && (
                    <div className="tw:flex tw:justify-end">
                        <MinusIcon className="tw:w-4 tw:h-4 tw:text-gray-400" />
                    </div>
                )}
            </TableCell>
            {/* Dynamic metric columns */}
            {selectedColumns.map((column) => {
                const value = getMetricValue(column.apiKey)
                const formattedValue = formatMetricValue(value, column)

                return (
                    <TableCell key={column.id} className="tw:text-right tw:text-sm tw:text-white tw:pr-3">
                        {formattedValue}
                    </TableCell>
                )
            })}
        </TableRow>
    )
}

export default Row
